import React from 'react';
import { routesUrl } from '../../../fuse-configs/navigationConfig';

const UsersManagementRouteConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.owners,
      exact: true,
      component: React.lazy(() => import('../usersManagement/ownersManagement/OwnersManagementPage')),
    },
  ],
};

export default UsersManagementRouteConfig;
